document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.lpcb-share-buttons__item');

    buttons.forEach((btn) => {
        const sns = btn.dataset.sns;

        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const url = window.location.href;
            const title = document.title;
            let shareUrl = '';

            switch (sns) {
                case 'x':
                    shareUrl = `http://twitter.com/share?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
                    break;
                case 'facebook':
                    shareUrl = `http://www.facebook.com/share.php?u=${encodeURIComponent(url)}&t=${encodeURIComponent(title)}`;
                    break;
                case 'pinterest':
                    shareUrl = `//jp.pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&t=${encodeURIComponent(title)}`;
                    break;
                case 'hatena':
                    shareUrl = `http://b.hatena.ne.jp/entry/${encodeURIComponent(url)}`;
                    break;
                case 'line':
                    shareUrl = `https://timeline.line.me/social-plugin/share?url=${encodeURIComponent(url)}`;
                    break;
                case 'copy':
                    navigator.clipboard.writeText(url).then(() => {
                        btn.classList.add('copied');
                        setTimeout(() => {
                            btn.classList.remove('copied');
                        }, 1500);
                    });
                    return;
                default:
                    return;
            }
            window.open(shareUrl, '_blank');
        });
    });
});
